import React from 'react'
// import SearchIcon from '@mui/icons-material/Search';
// import { IconName } from "react-icons/ai";
import { AiOutlineSearch, AiOutlineClose } from "react-icons/ai";
// import {logo1} from '../../../public/images';

// import './Navbar.css'
import { useSelector, useDispatch } from 'react-redux';
import ProfileButton from '../Navigation/ProfileButton';
import { NavLink } from 'react-router-dom/cjs/react-router-dom.min';
import { setSearchQuery } from '../../store/ui';


const Navbar = ({isLoaded}) => {
  const sessionUser = useSelector((state) => state.session.user)
  const searchQuery = useSelector((state) => state.ui.searchQuery)
  const dispatch = useDispatch()

  const handleSearchChange = (e) => {
    dispatch(setSearchQuery(e.target.value))
  }

  const handleClearSearch = () => {
    dispatch(setSearchQuery(''))
  }

  return (
    <>
    {sessionUser && (
      <div className={`h-auto lg:h-36 min-h-[6rem] bg-[--trailer_empty] sticky top-0 z-[3000] px-8 ${
        sessionUser?.is_admin
          ? 'animate-[adminPulse_4s_ease-in-out_infinite] bg-gradient-to-r from-blue-500/5 to-red-500/30'
          : ''
      }`}>
        <div className="h-full flex flex-col lg:flex-row justify-center items-center py-2">
          <NavLink to='/' className="shrink-0">
            <div className="flex items-center whitespace-nowrap my-2">
              <img
                className="size-30 lg:size-32  mix-blend-multiply"
                src='/images/modern-tech-logo2.png'
                alt='company-logo'
              />
              {/* <img
                className="size-15 lg:size-15 mix-blend-multiply"
                src='/images/yms-logo.png'
                alt='company-logo'
              /> */}
              <div className='flex flex-col ml-4'>
                <h1 className="text-8xl lg:text-[4rem] text-[#FF9900]">YMS</h1>
                <h4 className="text-xl lg:text-[1rem]">Yard Management System</h4>
              </div>
            </div>
          </NavLink>

          <div className="w-full flex gap-4 items-center">
            <div className="flex-1 flex justify-center items-center">
              <div className="relative flex items-center bg-gray-300 w-full lg:w-[50rem] max-w-full h-16 lg:h-20 rounded-lg p-4">
                <AiOutlineSearch style={{fontSize: '3rem'}}/>
                <input
                  type="text"
                  name=""
                  id="searchbar"
                  className="w-full bg-transparent outline-none border-none text-xl lg:text-2xl text-[--dark_background] font-extrabold ml-4 pr-14 placeholder-shown:focus:placeholder-transparent"
                  placeholder='Search ...'
                  value={searchQuery}
                  onChange={handleSearchChange}
                />
                {searchQuery && (
                  <button
                    onClick={handleClearSearch}
                    className="absolute right-4 bg-none border-none cursor-pointer text-gray-600 flex items-center p-2 hover:text-black transition-colors duration-200"
                  >
                    <AiOutlineClose style={{fontSize: '2rem'}}/>
                  </button>
                )}
              </div>
            </div>

            <ProfileButton className="shrink-0"/>
          </div>
        </div>
      </div>
    )}
    </>
  )
}

export default Navbar
